export default "__VITE_ASSET__CaTGQFdF__"